export const HUB_ACTUS = {
  HUB_ACTU_TITLE: 'HUB_ACTUS_TITLE',
};
